// src/components/course/CourseFilterBar.js
import React from "react";

function CourseFilterBar({
  minDistance,
  maxDistance,
  onMinChange,
  onMaxChange,
  onlyMyCourse,
  onToggleOnlyMyCourse,
}) {
  // 입력 필드 스타일 (투명 배경, 포커스 시 외곽선 없음)
  const inputClass =
    "w-10 text-center text-sm bg-transparent border-none focus:ring-0 focus:outline-none text-gray-800 font-bold placeholder-gray-400 p-0";

  return (
    <div className="flex items-center justify-between w-full mt-3">
      {/* 거리 필터: 회색 박스 + 안쪽 그림자 적용 */}
      <div className="flex items-center gap-2 bg-gray-100 rounded-xl px-4 py-2.5 shadow-inner">
        <span className="text-gray-500 text-xs font-bold mr-1">거리</span>
        <input
          type="number"
          placeholder="최소"
          value={minDistance ?? ""}
          onChange={(e) => onMinChange && onMinChange(e.target.value)}
          className={inputClass}
        />
        <span className="text-gray-400 text-xs">~</span>
        <input
          type="number"
          placeholder="최대"
          value={maxDistance ?? ""}
          onChange={(e) => onMaxChange && onMaxChange(e.target.value)}
          className={inputClass}
        />
        <span className="text-gray-500 text-xs font-bold ml-1">km</span>
      </div>

      {/* 내 코스만 버튼 */}
      <button
        type="button"
        onClick={onToggleOnlyMyCourse}
        className={`
            px-4 py-2 rounded-xl text-sm font-bold transition-all shadow-sm
            ${
              onlyMyCourse
                ? "bg-[rgb(0,224,198)] text-white"
                : "bg-white text-[rgb(0,224,198)] border border-[rgb(0,224,198)] hover:bg-gray-50"
            }
        `}
      >
        내 코스만
      </button>
    </div>
  );
}

export default CourseFilterBar;
